import { Breakpoints } from '@/hooks/useBreakpoint';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => theme.spacing[5]}px
    ${({ theme }) => theme.spacing[5]}px;
  gap: ${({ theme }) => theme.spacing[5]}px;
`;

export const ContainerTexto = styled.div<{ $breakpoint: Breakpoints }>`
  ${({ theme, $breakpoint }) => {
    if ($breakpoint === 'mobile')
      return css`
        display: flex;
        flex-direction: column;
      `;
    return css`
      background-color: ${theme.panel.solid};
      padding: ${theme.spacing[5]}px;
      border-radius: theme.radius[3]px;
    `;
  }}
`;

export const ContainerHTML = styled.div`
  font-family: var(--font-${({ theme }) => theme.typography.font.family.text});
  color: ${({ theme }) => theme.tokens.colors.text};
`;

export const ButtonContainer = styled.div<{ $breakpoint: Breakpoints }>`
  ${({ $breakpoint }) => {
    if ($breakpoint === 'mobile')
      return css`
        display: flex;
      `;
    return css`
      display: block;
      align-self: flex-end;
    `;
  }}
`;
